module.exports = __webpack_public_path__ + "img/[脸红].562fa5f6.svg";